module.exports = __webpack_public_path__ + "img/anonymous-icon.64dcc4ff.svg";